import { render } from "./SectionBegin.vue?vue&type=template&id=63285940"
import script from "./SectionBegin.vue?vue&type=script&lang=js"
export * from "./SectionBegin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__